/**
 * Application update notices shown in the sidebar bell (Notifications).
 *
 * Add an entry here with each change users should hear about; it ships with
 * the next deploy and shows as unread to everyone until they open the bell.
 * Newest first. `id` must be unique and never reused — read state is keyed
 * on it — so a date plus a short slug works well.
 */
export type ReleaseNoteKind = 'feature' | 'improvement' | 'fix';

export interface ReleaseNote {
  id: string;
  /** ISO date (YYYY-MM-DD) the change shipped. */
  date: string;
  kind: ReleaseNoteKind;
  title: string;
  details?: string;
  /** Optional in-app route to open from the notice, such as '/projects'. */
  link?: string;
}

export const RELEASE_NOTES: ReleaseNote[] = [
  {
    id: '2026-10-28-notifications',
    date: '2026-10-28',
    kind: 'feature',
    title: 'Notifications are live',
    details:
      'The bell now lists application updates as they ship. While you have ConXEdge open, '
      + 'it also tells you when a new version is deployed so you can refresh.',
  },
];
